import { AccountSearchQueryClient } from "../../../../../../Wrap/Api/Account/AccountSearchQuery";
import { AccountType } from "../../../../../../Wrap/Constants/Enums/Domain/AccountType";
import { MultiPropositionType } from "../../../../../../Wrap/Constants/Enums/Domain/MultiPropositionType";
import { AccountStatus } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { getStatus } from "../Resource/Content";

export interface IBasicSearchQuery {
    accountName?: string;
    accountNum?: string;
    accountType?: AccountType;
    status?: AccountStatus;
    network?: string;
    company?: string;
    advCode?: string;
    ServicePropositionsToExclude?: MultiPropositionType[];
}

export class AccountSearchAction {
    public static searchAccounts(query: IBasicSearchQuery, currentPage, count, callBack?: (val: any) => void): void {
        const client = new AccountSearchQueryClient();
        const promise = client.get(
            query.accountName,
            query.accountNum,
            query.advCode,
            query.accountType,
            getStatus(query.status),
            query.company,
            query.network,
            currentPage,
            count,
            null,
            null,
            null,
            null,
            null,
            null,
            query.ServicePropositionsToExclude
        );
        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });

        promise.onError((err) => {});
    }
}
